import { ContainerHeader, Typography } from 'shared/ui'
import { LINK_EMAIL_TO_SMS } from 'shared/constants/links'
import { LearnMoreLink } from 'pages/settings/ui/LearnMoreLink/LearnMoreLink'
import styles from './styles.module.scss'

export const EmailToSmsHeader = () => {
  return (
    <ContainerHeader
      customTitle={
        <header className={styles.header}>
          <Typography variant='heading-lg' ariaLabel='Email to SMS header'>
            Email to SMS
          </Typography>
          <Typography
            className={styles.headerDescription}
            variant='body-md-regular'
            ariaLabel='Email to SMS description'
          >
            Map Salesmsg inboxes to your emails to receive and reply to text messages via email.
            <LearnMoreLink href={LINK_EMAIL_TO_SMS}>Learn more</LearnMoreLink>
          </Typography>
        </header>
      }
      paddingTop={65}
      paddingBottom={0}
      paddingLeft={0}
      paddingRight={0}
      isAutoHeight={true}
    />
  )
}
